module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_2_5.ca604781.png";